import { 
  ADD_ANNOUNCEMENT,
  REMOVE_ANNOUNCEMENT,
  HIDE_ANNOUNCEMENT
} from "../actions/announcement";

export default function announcement(state = {
  text: null,
  show: true,
  lastUpdated: null
}, action) {
  switch (action.type) {
    case ADD_ANNOUNCEMENT:
      return {
        ...state,
        text: action.payload,
        lastUpdated: Date.now()
      };
    case REMOVE_ANNOUNCEMENT:
      return {
        ...state,
        text: null
      };
    case HIDE_ANNOUNCEMENT:
      return {
        ...state,
        show: false
      };
    default:
      return state;
  }
}